import React from "react";

import MapViews from "./MapViewsZenrin";
// style route map
import '../../assets/scss/route-map.scss';
import Format from '../../common/Format';
import Request from '../../common/Request';
import GsuiteAuth from "../../components/Auth/GsuiteAuth";

export default class EditList extends React.Component {
    constructor (props) {
        super (props);
        let parking_objects = []
        // console.log(this.props.location.state.parking)
        if (this.props.location.state.parking) {
            const original_parking = this.props.location.state.parking;
            original_parking.sort(function(beforeElements, afterElements){
                return beforeElements.site_distance_meter - afterElements.site_distance_meter
            })
            var i = 0;
            for ( var n = 0; n < original_parking.length; n ++ ) {
                if ( n % 3 == 0 ) { 
                    parking_objects.push([]);
                }
                parking_objects[i].push(original_parking[n]);
                if ( n % 3 == 2 ) {i ++}
            }
        }

        this.state = {
            ulid : this.props.location.state.ulid,
            request_data : undefined,
            parking_objects : [...parking_objects],
            parkings : this.props.location.state.parking? this.props.location.state.parking: undefined,
            flagged_parkings : []
        };


    }

    componentDidMount () {
        // 見積依頼のデータの取得
        var url = '/api/request/' + this.props.location.state.ulid;
        Request.get(url, {},
          res => {
            let requestData = res.Data
            let flaggedParking = []
            let distance = 10
            // console.log(this.state.parking_objects)
            this.state.parking_objects.map((m)=>{
                m.forEach((p)=>{
                    // console.log(p.site_distance_meter)
                    if (p.site_distance_meter>distance) {
                        distance = p.site_distance_meter
                    }
                })
            })
            // console.log(distance)
            const searchParmas = {
                request_ulid : this.state.ulid,
                search_distance: distance,
                latitude: requestData.latitude,
                longitude: requestData.longitude,
                request_parking_status: [2,3,4,5,6,7,8,9],
                // 2189
                distance_flag: false
                }
            
                Request.get("/api/request/parking/unlimit", searchParmas, res => {
                let copyRequestParkings = res.Data;
                copyRequestParkings.sort((a, b) => a.request_parking.site_distance_meter - b.request_parking.site_distance_meter)
                if (copyRequestParkings.length > 0) {
                    flaggedParking = [...copyRequestParkings]
                }
                this.setState({
                    request_data: requestData,
                    flagged_parkings:flaggedParking,
                })
            })
          }
        )
        //
    }

    callbackPushSurveyAdd(objects, destinates){
        // console.log(destinates, objects, this.state.parkings)

        let checkedItems = this.state.parkings
        checkedItems.sort((a, b) => a.request_parking.site_distance_meter - b.request_parking.site_distance_meter)
        const ulids = checkedItems.map((item)=>['ulid', item.request_parking.ulid])
        const params = new URLSearchParams(ulids);
          
        let parkingsData = this.state.parkings.map((p)=>{
            let ret = destinates.filter((dist)=>dist.request_parking_ulid == p.request_parking_ulid)
            let map_param = (ret)? ret[0]: {}
            let distance = (ret)? ret[0]['distance']: {}

            if('site_distance_meter' in distance && 'site_distance_minute' in distance) {
                // console.log('before ' + p['site_distance_meter'])
                // console.log('after ' + distance.site_distance_meter)
                p['site_distance_meter'] = distance.site_distance_meter
                p['site_distance_minute'] = distance.site_distance_minute
            }

            return {
                ...p,
                direction: {...map_param},
            }
        })
        // console.log(parkingsData)

        const states = {
            map_objects : objects,
            parking : parkingsData,
            flagged_parkings: this.state.flagged_parkings,
        }
  
        // 見積編集時と、新規,再見積は別URL
        this.isEdit() ? this.props.history.push({pathname: '/survey/estimate/edit', search: '?' + params.toString() + `&request_ulid=${this.state.ulid}` + '&previous=route_edit', state: states})
        : this.props.history.push({pathname: '/survey/estimate/add', search: '?' + params.toString() + `&request_ulid=${this.state.ulid}`, state: states})


        this.setState({checkedItems:[]});

/*
        Request.put("/api/request/"+this.state.ulid+'?' + params.toString(), {
          ...this.state.request_data,
          estimate_create_start_date:Format.dateToString(new Date(), 'YYYY-MM-DDThh:mm:ss')
        }, () => {
          this.props.history.push({pathname: '/survey/estimate/add', search: '?' + params.toString() + `&request_ulid=${this.state.ulid}`, state: states});
          this.setState({checkedItems:[]});
        },(err)=>{
          const {status, statusText} = err.response
          this.props.alertModal.current.showErrorModal({title:status, message:statusText});
        },undefined,true,true)
*/
    }

    render () {

        return (<>
        {this.state.request_data &&(<>
            <MapViews 
                request_data={this.state.request_data}
                parking_objects={this.state.parking_objects}
                flagged_parkings={this.state.flagged_parkings}
                callbackSaved={(objects,destinates)=>this.callbackPushSurveyAdd(objects,destinates)} 
                alertModal={this.props.alertModal}
            />
        </>)}
        </>);
    }

    // 見積編集からの表示判定(urlにeditが含まれている)
    isEdit(){
        return window.location.pathname.includes('/edit')
    }

}
